import React from 'react';
import PropTypes from 'prop-types';
import { Box, Button } from '@mui/material';
import { Iconify } from 'src/components';
import { tableCellInnerBoxStyle } from '../../../../styles/NewLeadTableRowStyle';

const CustomSelectTreatmentCell = ({ params, handleNext }) => {

    const handleClickEvent = (e) => {
        if (params?.row?.referral === 'WHATSAPP' || params?.row?.originalData?.lead_contact?.preferred_contact_method?.toLowerCase() === "whatsapp") {
            handleNext(params?.row, e, true);
        } else
            handleNext(params?.row, e);
    };

    const isWhatsApp = params?.row?.referral === 'WHATSAPP' || params?.row?.originalData?.lead_contact?.preferred_contact_method?.toLowerCase() === "whatsapp";

    return (
        <Box onClick={(e) => handleClickEvent(e)} sx={tableCellInnerBoxStyle} disabled={params?.row?.is_archive_pending}>
            <Button
                color='primary'
                variant='outlined'
                disabled={params?.row?.is_archive_pending}
                startIcon={isWhatsApp ? <Iconify icon={'ri:whatsapp-fill'} width={16} height={16} /> : undefined}
                sx={{ p: '6px 14px', fontSize: '0.8125rem', minWidth: '150px', boxShadow: '0px 2px 8px rgba(0, 167, 111, 0.2)', '&:hover': { backgroundColor: 'primary.main', color: 'common.white', boxShadow: '0px 4px 12px rgba(0, 167, 111, 0.24)', '& .MuiSvgIcon-root': { color: 'common.white' } } }}
            >
                Contact lead
            </Button>
        </Box>
    );
};

export default React.memo(CustomSelectTreatmentCell);

CustomSelectTreatmentCell.propTypes = {
    params: PropTypes.any,
    handleNext: PropTypes.func,
};